import { APIService } from '@services/api/common-services';
import { useMutation, UseMutateFunction } from '@tanstack/react-query';
import { APICONFIG } from '@config/api.config';
import { IJharokhaProductRes } from '.';

interface FetchProductParams {
	productCode: string;
	token: string;
}

export const useFetchProductQuery = (): {
	mutate: UseMutateFunction<IJharokhaProductRes, Error, FetchProductParams>;
	isPending: boolean;
	isError: boolean;
	error: Error | null;
	data: IJharokhaProductRes | undefined;
} => {
	const fetchProductDetails = async ({ productCode, token }: FetchProductParams): Promise<IJharokhaProductRes> => {
		return await APIService.getData<IJharokhaProductRes>(
			`${APICONFIG.JHAROKHA_PRODUCT}?material_code=${productCode}&customer_token=${token}`
		);
	};

	const { mutate, isPending, isError, error, data } = useMutation({
		mutationFn: fetchProductDetails,
	});

	return {
		mutate,
		isPending,
		isError,
		error,
		data,
	};
};
